import { render, staticRenderFns } from "./fb-contry-bar.vue?vue&type=template&id=b5b99ede&scoped=true"
import script from "./fb-contry-bar.vue?vue&type=script&lang=js"
export * from "./fb-contry-bar.vue?vue&type=script&lang=js"
import style0 from "./fb-contry-bar.vue?vue&type=style&index=0&id=b5b99ede&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b99ede",
  null
  
)

export default component.exports